<template>
  <div>
    <h5>Referenced DB entries</h5>
    <table class="table table-sm">
      <thead class="thead-light">
        <tr>
          <th>Id</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dbxref in dbxrefs" :key="dbxref.id">
          <td v-if="dbxref.link">
            <a v-bind:href="dbxref.link" target="_blank">{{ dbxref.id }}</a>
          </td>
          <td v-else>{{ dbxref.id }}</td>
          <td>{{ dbxref.description }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ReferencesTable",
  props: ["dbxrefs"]
};
</script>
